import { render } from "./PageListarCalculoSituacao.vue?vue&type=template&id=0bd46e54"
import script from "./PageListarCalculoSituacao.vue?vue&type=script&lang=js"
export * from "./PageListarCalculoSituacao.vue?vue&type=script&lang=js"

import "./PageListarCalculoSituacao.vue?vue&type=style&index=0&id=0bd46e54&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__